import { motion } from "framer-motion";
import { Music2 } from "lucide-react";
import PageHeader from "../components/PageHeader";
import CommentsSection from "../components/CommentsSection";
import { ownSongs } from "../data/content";

export default function Music() {
  return (
    <div data-testid="page-music">
      <PageHeader
        eyebrow="Music Corner"
        title="A guitar, a small mic, and a quiet hour."
        intro="These are the songs I have recorded at home — covers I have loved for years, and one or two of my own. No studios, no producers. Just the room, the strings, and what came out that morning."
        testid="music-header"
      />

      <section className="pb-24">
        <div className="container-narrow">
          <div className="grid md:grid-cols-2 gap-8" data-testid="music-grid">
            {ownSongs.map((s, i) => (
              <motion.article
                key={`${s.title}-${i}`}
                initial={{ opacity: 0, y: 22 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.2 }}
                transition={{ duration: 0.55, delay: i * 0.07 }}
                className="rounded-sm bg-[#F2EFEB] border border-[#D8D3CC] overflow-hidden card-lift"
                data-testid={`music-card-${i}`}
              >
                <div className="aspect-video bg-[#2C2A28]">
                  <iframe
                    title={s.title}
                    src={`https://www.youtube.com/embed/${s.youtubeId}`}
                    className="w-full h-full"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  />
                </div>
                <div className="p-6 sm:p-7">
                  <div className="flex items-center gap-2">
                    <Music2 size={16} className="text-[#CC7A52]" strokeWidth={1.6} />
                    <span className="eyebrow !text-[#CC7A52] !text-[10px]">
                      Home recording
                    </span>
                  </div>
                  <h3 className="font-serif text-2xl sm:text-3xl mt-3 text-[#2C2A28] leading-tight">
                    {s.title}
                  </h3>
                  <p className="mt-3 text-[#5C5852] leading-relaxed">{s.note}</p>
                  <CommentsSection
                    page="Music Corner"
                    itemId={s.title}
                    itemTitle={s.title}
                  />
                </div>
              </motion.article>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
